import { createButton } from 'react-simple-wysiwyg';

import { Underline01Icon } from '@/assets/icons/Underline01Icon';

export default createButton('Underline', <Underline01Icon />, 'underline');
